import React from 'react'
import styled from 'styled-components'
import { THEME } from './globalStyles';

export function PrymaryButton({children,secondary,disabled,...rest}){
  return (
    <Button1 disabled={disabled} secondary={secondary} {...rest}>
      {children}
    </Button1>
  )
}

const Button1 = styled.button`
  border:none;
  background: none;
  background-color: ${p=>p.secondary?'none':THEME.colors.blue}${p=>p.disabled?'55':''};
  border: 1px solid ${THEME.colors.blue}${p=>p.disabled?'55':''};
  border-radius: 40px;
  padding: 8px 30px;
  width: 100%;
  /* height: 32px; */
  color: ${p=>p.secondary?THEME.colors.blue:'#FFF'};
`;